<template>
    <div class="dettaglio-card">
      <div class="dettaglio-header">
        <span>Credito da Gestire</span>
      </div>
      <div style="padding: 16px; position: relative;">
        <div v-if="loading" class="overlay-loading">
          <Loader />
        </div>
        
        <div v-if="agentiMaster.length > 0" class="filters-section">
          <div class="filters-row">
            <div class="filter-field">
              <label>Filtra per Agente:</label>
              <InputText 
                v-model="filterAgente" 
                placeholder="Digita per filtrare gli agenti..." 
            :disabled="loading"
          />
            </div>
            <div class="filter-field">
              <Button 
                :label="fatture180ggActive ? 'Scandenza Fatture oltre 180 giorni ✓' : 'Scandenza Fatture oltre 180 giorni'"
                :class="['btn-180gg', { 'active': fatture180ggActive }]"
                @click="toggleFatture180gg"
                :disabled="loading"
              />
            </div>
          </div>
        </div>
             
      <div v-if="!initialLoaded && !loading" class="empty-state">
        <p>Inizializzazione in corso...</p>
      </div>

      <div v-else-if="initialLoaded && !loading && (!agentiMaster || agentiMaster.length === 0)" class="empty-state">
        <p>Nessun dato disponibile</p>
      </div>

      <Accordion v-else-if="(filteredAgentiMaster && filteredAgentiMaster.length)" :multiple="true" :key="`agenti-master-${filteredAgentiMaster.length}-${accordionKey}`" @tab-open="onAgenteMasterExpand">
        <AccordionTab v-for="agenteMaster in filteredAgentiMaster" :key="`master-${agenteMaster.agente_id}`">
          <template #header>
            <div class="agente-master-header">
              <span>{{ agenteMaster.agenzia || 'Agente Master' }} - Insoluto Totale: {{ formatEuro(agenteMaster.insoluto_totale) }}</span>
              <span v-if="loadingFirmatari.get(agenteMaster.master_agente_id || agenteMaster.agente_id)" class="loading-indicator">
                <i class="pi pi-spin pi-spinner"></i>
              </span>
            </div>
          </template>
          
          <div v-if="loadingFirmatari.get(agenteMaster.master_agente_id || agenteMaster.agente_id)" class="loading-content">
            <i class="pi pi-spin pi-spinner"></i> Caricamento agenti firmatari...
          </div>
          
          <Accordion v-else-if="getAgentiFirmatari(agenteMaster.master_agente_id || agenteMaster.agente_id).length" :multiple="true" @tab-open="(event) => onAgenteFirmatarioExpand(agenteMaster.master_agente_id || agenteMaster.agente_id, event)">
            <AccordionTab v-for="firmatario in getAgentiFirmatari(agenteMaster.master_agente_id || agenteMaster.agente_id)" :key="`firmatario-${firmatario.agente_firmatario_id}`">
              <template #header>
                <div class="firmatario-header">
                  <span>{{ firmatario.agente_firmatario_name }} - Insoluto: {{ formatEuro(firmatario.insoluto_firmatario) }}</span>
                  <span v-if="loadingRappresentanti.get(firmatario.agente_firmatario_id)" class="loading-indicator">
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                </div>
              </template>
              
              <div v-if="loadingRappresentanti.get(firmatario.agente_firmatario_id)" class="loading-content">
                <i class="pi pi-spin pi-spinner"></i> Caricamento rappresentanti...
              </div>
              
              <Accordion v-else-if="getRappresentanti(firmatario.agente_firmatario_id).length" :multiple="true" @tab-open="(event) => onRappresentanteExpand(firmatario.agente_firmatario_id, event)">
                <AccordionTab v-for="rappresentante in getRappresentanti(firmatario.agente_firmatario_id)" :key="`rappresentante-${rappresentante.rappresentante_id}`">
                  <template #header>
                    <div class="rappresentante-header">
                       <span class="link" @click.stop="navigateToIncallByName('rappresentante', rappresentante.rappresentante_name)">
                         {{ rappresentante.rappresentante_name }}<span v-if="rappresentante.rappresentante_id !== 0"> - Insoluto: {{ formatEuro(rappresentante.insoluto_rappresentante) }}</span>
                       </span>
                      <span v-if="rappresentante.rappresentante_id === 0 ? loadingClienti.get(`firmatario_${firmatario.agente_firmatario_id}`) : loadingClienti.get(rappresentante.rappresentante_id)" class="loading-indicator">
                        <i class="pi pi-spin pi-spinner"></i>
                      </span>
                      <button 
                        v-if="rappresentante.rappresentante_id !== 0"
                        class="btn-recupero-credito" 
                        :disabled="rappresentante.esito_gestione_credito === 1"
                        :title="rappresentante.esito_gestione_credito === 1 ? 'Esiste una data rimanda' : ''"
                        @click.stop="openRecuperoCreditoRappresentante(rappresentante.rappresentante_id)"
                      >
                        Recupero Credito
                      </button>
                    </div>
                  </template>
                  
                  <div v-if="rappresentante.rappresentante_id === 0 ? loadingClienti.get(`firmatario_${firmatario.agente_firmatario_id}`) : loadingClienti.get(rappresentante.rappresentante_id)" class="loading-content">
                    <i class="pi pi-spin pi-spinner"></i> Caricamento clienti...
                  </div>
                  
                  <Accordion v-else-if="getClienti(rappresentante.rappresentante_id, firmatario.agente_firmatario_id).length" :multiple="true">
                    <AccordionTab v-for="cliente in getClienti(rappresentante.rappresentante_id, firmatario.agente_firmatario_id)" :key="`cliente-${cliente.cliente_id}`">
                      <template #header>
                        <span>
                          <span class="link" @click.stop="navigateToIncallByName('cliente', cliente.cliente)">{{ cliente.cliente }}</span>
                          <span> - Saldo: {{ formatEuro(cliente.cliente_saldo) }}</span>
                        </span>
                      </template>
                      
                      <DataTable :value="cliente.fatture" dataKey="numero" responsiveLayout="scroll" showGridlines paginator :rows="20" :rowsPerPageOptions="[20,40,80]" emptyMessage="Nessuna fattura">
                        <Column field="numero" header="N. Fattura" sortable>
                          <template #body="slotProps">
                            <span class="link" @click="navigateToFatturaDetail(slotProps.data.numero)">
                              {{ slotProps.data.numero }}
                            </span>
                          </template>
                        </Column>
                        <Column header="PDP">
                          <template #body="slotProps">
                            <span class="link" @click="navigateToPdpDetail(slotProps.data)">
                              {{ displayPdp(slotProps.data) }}
                            </span>
                          </template>
                        </Column>
                        <Column field="data_emissione" header="Emissione" sortable />
                        <Column field="data_scadenza" header="Scadenza" sortable />
                        <Column field="data_fine_pdp" header="Data Fine PDP" sortable />
                        <Column header="Stato PDP">
                          <template #body="slotProps">
                            {{ displayStatoPdp(slotProps.data) }}
                          </template>
                        </Column>
                        <Column field="tot_fattura" header="Totale" :body="row => formatEuro(row.tot_fattura)" :footer="formatEuro(sumField(cliente.fatture, 'tot_fattura'))" :bodyClass="'text-right'" :headerClass="'text-right'" :footerClass="'text-right'" sortable />
                        <Column field="saldo" header="Saldo" :body="row => formatEuro(row.saldo)" :footer="formatEuro(sumField(cliente.fatture, 'saldo'))" :bodyClass="'text-right'" :headerClass="'text-right'" :footerClass="'text-right'" sortable />
                        <Column header="Contatto">
                          <template #body="slotProps">
                            <button class="btn-tertiary" @click="openContatti(slotProps.data)">Visualizza</button>
                          </template>
                        </Column>
                        <Column header="Dilazione">
                          <template #body="slotProps">
                            <span>{{ slotProps.data.numero_dilazione ? 'SI' : 'NO' }}</span>
                          </template>
                        </Column>
                        <Column header="Recupero Credito">
                          <template #body="slotProps">
                            <button 
                              class="btn-recupero-credito-small" 
                              :disabled="slotProps.data.esito_gestione_credito === 1"
                              :title="slotProps.data.esito_gestione_credito === 1 ? 'Esiste una data rimanda' : ''"
                              @click="openRecuperoCreditoCliente(cliente.cliente_id)"
                            >
                              Recupero Credito
                            </button>
                          </template>
                        </Column>
                      </DataTable>
                    </AccordionTab>
                  </Accordion>
                  <div v-else class="empty-level">Nessun cliente trovato</div>
                </AccordionTab>
              </Accordion>
              
              <div v-else>
                 <div class="no-rappresentanti-header" v-if="getRappresentanti(firmatario.agente_firmatario_id).find(r => r.rappresentante_id === 0)">
                   <span class="link" @click.stop="navigateToIncallByName('rappresentante', 'Senza rappresentante')">
                     {{ getRappresentanti(firmatario.agente_firmatario_id).find(r => r.rappresentante_id === 0)?.rappresentante_name || 'Senza rappresentante' }}
                   </span>
                  <span v-if="loadingClienti.get(`firmatario_${firmatario.agente_firmatario_id}`)" class="loading-indicator">
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                </div>
                 <div class="no-rappresentanti-header" v-else>
                   <span class="link" @click.stop="navigateToIncallByName('rappresentante', 'Senza rappresentante')">
                     Senza rappresentante
                   </span>
                  <span v-if="loadingClienti.get(`firmatario_${firmatario.agente_firmatario_id}`)" class="loading-indicator">
                    <i class="pi pi-spin pi-spinner"></i>
                  </span>
                </div>
                
                <div v-if="loadingClienti.get(`firmatario_${firmatario.agente_firmatario_id}`)" class="loading-content">
                  <i class="pi pi-spin pi-spinner"></i> Caricamento clienti...
                </div>
                
                <Accordion v-else-if="getClienti(`firmatario_${firmatario.agente_firmatario_id}`).length" :multiple="true">
                  <AccordionTab v-for="cliente in getClienti(`firmatario_${firmatario.agente_firmatario_id}`)" :key="`cliente-${cliente.cliente_id}`">
                    <template #header>
                      <span>
                        <span class="link" @click.stop="navigateToIncallByName('cliente', cliente.cliente)">{{ cliente.cliente }}</span>
                        <span> - Saldo: {{ formatEuro(cliente.cliente_saldo) }}</span>
                      </span>
                    </template>
                    
                    <DataTable :value="cliente.fatture" dataKey="numero" responsiveLayout="scroll" showGridlines paginator :rows="20" :rowsPerPageOptions="[20,40,80]" emptyMessage="Nessuna fattura">
                      <Column field="numero" header="N. Fattura" sortable>
                        <template #body="slotProps">
                          <span class="link" @click="navigateToFatturaDetail(slotProps.data.numero)">
                            {{ slotProps.data.numero }}
                          </span>
                        </template>
                      </Column>
                      <Column header="PDP">
                        <template #body="slotProps">
                          <span class="link" @click="navigateToPdpDetail(slotProps.data)">
                            {{ displayPdp(slotProps.data) }}
                          </span>
                        </template>
                      </Column>
                      <Column field="data_emissione" header="Emissione" sortable />
                      <Column field="data_scadenza" header="Scadenza" sortable />
                      <Column field="data_fine_pdp" header="Data Fine PDP" sortable />
                      <Column header="Stato PDP">
                        <template #body="slotProps">
                          {{ displayStatoPdp(slotProps.data) }}
                        </template>
                      </Column>
                      <Column field="tot_fattura" header="Totale" :body="row => formatEuro(row.tot_fattura)" :footer="formatEuro(sumField(cliente.fatture, 'tot_fattura'))" :bodyClass="'text-right'" :headerClass="'text-right'" :footerClass="'text-right'" sortable />
                      <Column field="saldo" header="Saldo" :body="row => formatEuro(row.saldo)" :footer="formatEuro(sumField(cliente.fatture, 'saldo'))" :bodyClass="'text-right'" :headerClass="'text-right'" :footerClass="'text-right'" sortable />
                        <Column header="Contatto">
                          <template #body="slotProps">
                            <button class="btn-tertiary" @click="openContatti(slotProps.data)">Visualizza</button>
                          </template>
                        </Column>
                        <Column header="Dilazione">
                          <template #body="slotProps">
                            <span>{{ slotProps.data.numero_dilazione ? 'SI' : 'NO' }}</span>
                          </template>
                        </Column>
                        <Column header="Recupero Credito">
                          <template #body="slotProps">
                            <button 
                              class="btn-recupero-credito-small" 
                              :disabled="slotProps.data.esito_gestione_credito === 1"
                              :title="slotProps.data.esito_gestione_credito === 1 ? 'Esiste una data rimanda' : ''"
                              @click="openRecuperoCreditoCliente(cliente.cliente_id)"
                            >
                              Recupero Credito
                            </button>
                          </template>
                        </Column>
                      </DataTable>
                    </AccordionTab>
                  </Accordion>
                <div v-else class="empty-level">Nessun cliente trovato</div>
              </div>
                </AccordionTab>
              </Accordion>
          <div v-else class="empty-level">Nessun agente firmatario trovato</div>
            </AccordionTab>
          </Accordion>

      <Dialog v-model:visible="showContatti" :modal="true" :draggable="false" header="Contatti cliente" :style="{ width: '460px' }">
        <div class="contatti-box">
          <div><strong>Email:</strong> {{ contattiData?.contatti?.email || '-' }}</div>
          <div><strong>Telefono:</strong> {{ contattiData?.contatti?.tel || '-' }}</div>
          <div><strong>Cellulare:</strong> {{ contattiData?.contatti?.cell || '-' }}</div>
        </div>
        <template #footer>
          <button class="btn-primary" @click="showContatti=false">Chiudi</button>
        </template>
      </Dialog>

      
    </div>
  </div>
</template>

<script>
import Service from '@/services/ask-management/recupero-credito-service'
import { getCurrentInstance, onMounted, ref, computed, nextTick } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Loader from '@/components/Loader.vue'
import moment from 'moment'


export default {
  components: { DataTable, Column, Accordion, AccordionTab, Dialog, InputText, Button, Loader },
  setup() {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    const loading = ref(false);
    const agentiMaster = ref([]);
    const initialLoaded = ref(false);
    const accordionKey = ref(0);
    let loadingRequest = null;
    const filterAgente = ref('');
    const filterRappresentante = ref('');
    const filterCliente = ref('');
    const fatture180ggActive = ref(false);
    
    const filteredAgentiMaster = computed(() => {
      if (!filterAgente.value.trim()) {
        return agentiMaster.value;
      }
      
      const searchTerm = filterAgente.value.toLowerCase().trim();
      return agentiMaster.value.filter(agente => {
        const agenziaNome = (agente.agenzia || '').toLowerCase();
        return agenziaNome.includes(searchTerm);
      });
    });
    
    const agentiFirmatariCache = ref(new Map());
    const rappresentantiCache = ref(new Map());
    const clientiCache = ref(new Map());
    
    const loadingFirmatari = ref(new Map());
    const loadingRappresentanti = ref(new Map());
    const loadingClienti = ref(new Map());

    const reportError = (message, error = null) => {
      self.$eventBus?.emit('data-load-error', { message, error });
    };
    

    const loadAgentiMaster = async () => {
      loading.value = true;
      try {
        const filters = { filter_type: 'default' };
        if (fatture180ggActive.value) {
          filters.fatture180gg = true;
        }
        loadingRequest = service.getCreditoDaGestire(filters);
        const res = await loadingRequest;
        
        if (res && res.success) {
          const data = Array.isArray(res.data) ? res.data : [];
          agentiMaster.value = data.sort((a, b) => {
            const insolutoA = Number(a.insoluto_totale || 0);
            const insolutoB = Number(b.insoluto_totale || 0);
            return insolutoB - insolutoA;
          });
          
          agentiFirmatariCache.value.clear();
          rappresentantiCache.value.clear();
          clientiCache.value.clear();
          
          await nextTick();
        } else {
          reportError('Risposta non valida dal server', res);
          agentiMaster.value = [];
        }
      } catch (e) {
        if (e.name !== 'AbortError') {
          reportError('Errore nel caricamento agenti master', e);
        }
        agentiMaster.value = [];
      } finally {
        loading.value = false;
        loadingRequest = null;
        if (!initialLoaded.value) initialLoaded.value = true;
      } 
    };

    const loadAgentiFirmatari = async (agenteMasterId) => {
      if (agentiFirmatariCache.value.has(agenteMasterId)) {
        return agentiFirmatariCache.value.get(agenteMasterId);
      }
      
      loadingFirmatari.value.set(agenteMasterId, true);
      
      try {
        const params = { filter_type: 'default' };
        if (filterAgente.value.trim()) params.agente_name = filterAgente.value.trim();
        if (filterRappresentante.value.trim()) params.rappresentante_name = filterRappresentante.value.trim();
        if (filterCliente.value.trim()) params.cliente_name = filterCliente.value.trim();
        
        const res = await service.getAgentiFirmatari(agenteMasterId, params);
        
        if (res && res.success) {
          const firmatari = Array.isArray(res.data) ? res.data : [];
          agentiFirmatariCache.value.set(agenteMasterId, firmatari);
          return firmatari;
        }
      } catch (error) {
        reportError('Errore nel caricamento agenti firmatari', error);
      } finally {
        loadingFirmatari.value.set(agenteMasterId, false);
      }
      
      return [];
    };

    const loadRappresentanti = async (agenteFirmatarioId) => {
      if (rappresentantiCache.value.has(agenteFirmatarioId)) {
        const cached = rappresentantiCache.value.get(agenteFirmatarioId);
        return cached;
      }
      
      loadingRappresentanti.value.set(agenteFirmatarioId, true);
      
      try {
        const params = { filter_type: 'default' };
        if (filterAgente.value.trim()) params.agente_name = filterAgente.value.trim();
        if (filterRappresentante.value.trim()) params.rappresentante_name = filterRappresentante.value.trim();
        if (filterCliente.value.trim()) params.cliente_name = filterCliente.value.trim();
        
        const res = await service.getRappresentanti(agenteFirmatarioId, params);
        
        if (res && res.success) {
          const rappresentanti = Array.isArray(res.data) ? res.data : [];
          rappresentantiCache.value.set(agenteFirmatarioId, rappresentanti);
          return rappresentanti;
        }
      } catch (error) {
        reportError('Errore nel caricamento rappresentanti', error);
      } finally {
        loadingRappresentanti.value.set(agenteFirmatarioId, false);
      }
      
      return [];
    };

    const normalizeFattureFromRow = (row) => {
      const nestedFatture = Array.isArray(row.fatture)
        ? row.fatture
        : (Array.isArray(row.future) ? row.future : []);

      if (nestedFatture.length) {
        return nestedFatture.map((fattura) => ({
          numero: fattura.numero,
          data_emissione: fattura.data_emissione,
          data_scadenza: fattura.data_scadenza,
          tot_fattura: fattura.tot_fattura,
          saldo: fattura.saldo,
          pod_code: fattura.pod_code,
          pod_id: fattura.pod_id,
          pod_cod_type_state: fattura.pod_cod_type_state,
          pdr_code: fattura.pdr_code,
          pdr_id: fattura.pdr_id,
          pdr_cod_type_state: fattura.pdr_cod_type_state,
          data_fine_pdp: fattura.data_fine_pdp,
          stato_pod: fattura.stato_pod,
          stato_pdr: fattura.stato_pdr,
          numero_dilazione: fattura.numero_dilazione,
          esito_gestione_credito: fattura.esito_gestione_credito ?? row.esito_gestione_credito,
          contatti: {
            email: fattura.email ?? row.email,
            tel: fattura.tel ?? row.tel,
            cell: fattura.cell ?? row.cell
          }
        }));
      }

      return [{
        numero: row.numero,
        data_emissione: row.data_emissione,
        data_scadenza: row.data_scadenza,
        tot_fattura: row.tot_fattura,
        saldo: row.saldo,
        pod_code: row.pod_code,
        pod_id: row.pod_id,
        pod_cod_type_state: row.pod_cod_type_state,
        pdr_code: row.pdr_code,
        pdr_id: row.pdr_id,
        pdr_cod_type_state: row.pdr_cod_type_state,
        data_fine_pdp: row.data_fine_pdp,
        stato_pod: row.stato_pod,
        stato_pdr: row.stato_pdr,
        numero_dilazione: row.numero_dilazione,
        esito_gestione_credito: row.esito_gestione_credito,
        contatti: {
          email: row.email,
          tel: row.tel,
          cell: row.cell
        }
      }];
    };

    const extractClientiData = (data) => {
      if (Array.isArray(data)) {
        return data;
      }

      if (data && typeof data === 'object') {
        if (Array.isArray(data.data)) {
          return data.data;
        }

        if (Array.isArray(data.items)) {
          return data.items;
        }

        const numericKeys = Object.keys(data)
          .filter((key) => /^\d+$/.test(key))
          .sort((a, b) => Number(a) - Number(b));

        if (numericKeys.length) {
          return numericKeys
            .map((key) => data[key])
            .filter((item) => item && typeof item === 'object');
        }
      }

      return [];
    };

    const normalizeClienteRow = (row) => {
      const clienteName = row?.cliente_name || row?.cliente || 'Cliente sconosciuto';
      const fatture = normalizeFattureFromRow(row || {});

      return {
        cliente: clienteName,
        cliente_id: row?.cliente_id,
        cliente_saldo: row?.cliente_saldo,
        esito_gestione_credito: row?.esito_gestione_credito,
        fatture
      };
    };

    const loadClienti = async (rappresentanteId) => {
      if (clientiCache.value.has(rappresentanteId)) {
        return clientiCache.value.get(rappresentanteId);
      }
      
      loadingClienti.value.set(rappresentanteId, true);
      
      try {
        const params = { filter_type: 'default' };
        if (filterAgente.value.trim()) params.agente_name = filterAgente.value.trim();
        if (filterRappresentante.value.trim()) params.rappresentante_name = filterRappresentante.value.trim();
        if (filterCliente.value.trim()) params.cliente_name = filterCliente.value.trim();
        
        const res = await service.getClienti(rappresentanteId, params);
        
        if (res && res.success) {
          const clientiData = extractClientiData(res.data);
          const clienti = clientiData.map(normalizeClienteRow);
          clientiCache.value.set(rappresentanteId, clienti);
          return clienti;
        }
      } catch (error) {
        reportError('Errore nel caricamento clienti', error);
      } finally {
        loadingClienti.value.set(rappresentanteId, false);
      }
      
      return [];
    };

    const loadClientiByFirmatario = async (agenteFirmatarioId) => {
      const cacheKey = `firmatario_${agenteFirmatarioId}`;
      
      if (clientiCache.value.has(cacheKey)) {
        return clientiCache.value.get(cacheKey);
      }
      
      loadingClienti.value.set(cacheKey, true);
      
      try {
        const params = { filter_type: 'default' };
        if (filterAgente.value.trim()) params.agente_name = filterAgente.value.trim();
        if (filterRappresentante.value.trim()) params.rappresentante_name = filterRappresentante.value.trim();
        if (filterCliente.value.trim()) params.cliente_name = filterCliente.value.trim();
        
        const res = await service.getClientiByFirmatario(agenteFirmatarioId, params);
        
        if (res && res.success) {
          const clientiData = extractClientiData(res.data);
          const clienti = clientiData.map(normalizeClienteRow);
          clientiCache.value.set(cacheKey, clienti);
          return clienti;
        }
      } catch (error) {
        reportError('Errore nel caricamento clienti per firmatario', error);
      } finally {
        loadingClienti.value.set(cacheKey, false);
      }
      
      return [];
    };

    const onAgenteMasterExpand = async (event) => {
      const agenteMaster = filteredAgentiMaster.value[event.index];
      
      if (agenteMaster) {
        const agenteMasterId = agenteMaster.master_agente_id || agenteMaster.agente_id;
        
        if (agenteMasterId) {
          await loadAgentiFirmatari(agenteMasterId);
        }
      }
    };

    const onAgenteFirmatarioExpand = async (agenteMasterId, event) => {
      const firmatari = agentiFirmatariCache.value.get(agenteMasterId);
      if (firmatari && firmatari[event.index]) {
        const firmatario = firmatari[event.index];
        
        const rappresentanti = await loadRappresentanti(firmatario.agente_firmatario_id);
        
        const hasRealRappresentanti = rappresentanti && rappresentanti.length > 0 && rappresentanti.some(r => r.rappresentante_id > 0);
        
        if (!hasRealRappresentanti) {
          await loadClientiByFirmatario(firmatario.agente_firmatario_id);
        }
      }
    };

    const onRappresentanteExpand = async (agenteFirmatarioId, event) => {
      const rappresentanti = rappresentantiCache.value.get(agenteFirmatarioId);
      if (rappresentanti && rappresentanti[event.index]) {
        const rappresentante = rappresentanti[event.index];

        if (rappresentante.rappresentante_id === 0) {
          await loadClientiByFirmatario(agenteFirmatarioId);
        } else {
          await loadClienti(rappresentante.rappresentante_id);
        }
      }
    };

    const getAgentiFirmatari = (agenteMasterId) => {
      return agentiFirmatariCache.value.get(agenteMasterId) || [];
    };

    const getRappresentanti = (agenteFirmatarioId) => {
      return rappresentantiCache.value.get(agenteFirmatarioId) || [];
    };

    const getClienti = (rappresentanteId, agenteFirmatarioId = null) => {
      if (rappresentanteId === 0 && agenteFirmatarioId) {
        const cacheKey = `firmatario_${agenteFirmatarioId}`;
        const result = clientiCache.value.get(cacheKey) || [];
        return result;
      }
      const result = clientiCache.value.get(rappresentanteId) || [];
      return result;
    };


    const formatEuro = (value) => {
      const num = Number(value || 0);
      return `€ ${num.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };
    const sumField = (items, field) => (Array.isArray(items) ? items.reduce((s, r) => s + Number(r[field] || 0), 0) : 0);

    const displayPdp = (row) => {
      if (row && row.pod_code) return row.pod_code;
      if (row && row.pdr_code) return row.pdr_code;
      return '-';
    };

    const displayStatoPdp = (row) => {
      if (row && row.stato_pod) return row.stato_pod;
      if (row && row.stato_pdr) return row.stato_pdr;
      return '-';
    };

    const navigateToPdpDetail = (row) => {
      if (!row) return;
      if (row.pod_id) {
        window.open(`/ask/pods/${row.pod_id}/dettagli`, '_blank');
        return;
      }
      if (row.pdr_id) {
        window.open(`/ask/pdrs/${row.pdr_id}/dettagli`, '_blank');
      }
    };

    const navigateToFatturaDetail = (numero) => {
      if (!numero) return;
      window.open(`/ask/clienti/fatture/${numero}/dettagli`, '_blank');
    };

    const navigateToIncall = (type, id) => {
      if (!id) return;
      const params = new URLSearchParams();
      params.set(type === 'rappresentante' ? 'rappresentante_id' : 'cliente_id', id);
      window.open(`/in-call?${params.toString()}`, '_blank');
    };

    const navigateToIncallByName = (type, name) => {
      if (!name) return;
      const params = new URLSearchParams();
      params.set('search_type', type);
      params.set('q', name);
      window.open(`/in-call?${params.toString()}`, '_blank');
    };

    const showContatti = ref(false);
    const contattiData = ref(null);


    const openContatti = (row) => {
      contattiData.value = row || {};
      showContatti.value = true;
    };

    const openRecuperoCreditoCliente = async (clienteId) => {
      if (!clienteId) {
        reportError('ID cliente non disponibile');
        return;
      }
      
      try {
        const url = `/recupero-credito?cliente_id=${clienteId}`;
        window.open(url, '_blank');
      } catch (error) {
        reportError('Errore nell\'apertura del recupero credito cliente', error);
      }
    };

    const openRecuperoCreditoRappresentante = async (rappresentanteId) => {
      if (!rappresentanteId) {
        reportError('ID rappresentante non disponibile');
        return;
      }
      
      try {
        const url = `/recupero-credito?rappresentante_id=${rappresentanteId}`;
        window.open(url, '_blank');
      } catch (error) {
        reportError('Errore nell\'apertura del recupero credito rappresentante', error);
      }
    };

    const hasEsitoPresente = (fatture) => {
      if (!Array.isArray(fatture)) return false;
      return fatture.some(fattura => fattura.esito_presente === 1);
    };

    const isRecuperoCreditoDisabled = (cliente) => {
      if (cliente.rimanda_presente === 1) return true;
      return hasEsitoPresente(cliente.fatture);
    };

    const getRecuperoCreditoTooltip = (cliente) => {
      if (cliente.rimanda_presente === 1) {
        return 'Recupero Credito non disponibile - Rimanda presente per questo cliente';
      }
      if (hasEsitoPresente(cliente.fatture)) {
        return 'Recupero Credito non disponibile - Esito già presente su una o più fatture';
      }
      return 'Apri Recupero Credito per questo cliente';
    };

    const getRecuperoCreditoTooltipRappresentante = (rappresentante) => {
      if (rappresentante.rimanda_presente === 1) {
        return 'Recupero Credito non disponibile - Rimanda presente per questo rappresentante';
      }
      if (rappresentante.esito_presente === 1) {
        return 'Recupero Credito non disponibile - Esito già presente';
      }
      return 'Apri Recupero Credito per questo rappresentante';
    };

    const formatDate = (date) => {
      return moment(date).format('DD/MM/YYYY');
    };

    const toggleFatture180gg = async () => {
      fatture180ggActive.value = !fatture180ggActive.value;
      await loadAgentiMaster();
      agentiFirmatariCache.value.clear();
      rappresentantiCache.value.clear();
      clientiCache.value.clear();
      accordionKey.value++; 
    };

    onMounted(() => {
      loadAgentiMaster();
    });

    return {
      service,
      loading,
      agentiMaster,
      filteredAgentiMaster,
      initialLoaded,
      accordionKey,
      filterAgente,
      filterRappresentante,
      filterCliente,
      fatture180ggActive,
      toggleFatture180gg,
      loadAgentiFirmatari,
      loadRappresentanti,
      loadClienti,
      loadClientiByFirmatario,
      agentiFirmatariCache,
      rappresentantiCache,
      clientiCache,
      loadingFirmatari,
      loadingRappresentanti,
      loadingClienti,
      onAgenteMasterExpand,
      onAgenteFirmatarioExpand,
      onRappresentanteExpand,
      getAgentiFirmatari,
      getRappresentanti,
      getClienti,
      formatEuro,
      sumField,
      displayPdp,
      displayStatoPdp,
      navigateToPdpDetail,
      navigateToFatturaDetail,
      navigateToIncall,
      navigateToIncallByName,
      showContatti,
      contattiData,
      openContatti,
      openRecuperoCreditoCliente,
      openRecuperoCreditoRappresentante,
      hasEsitoPresente,
      isRecuperoCreditoDisabled,
      formatDate,
      getRecuperoCreditoTooltip,
      getRecuperoCreditoTooltipRappresentante
    };
  }
}
</script>

<style scoped>
.rappresentante-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.btn-recupero-credito {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}

.btn-recupero-credito:hover:not(:disabled):not(.disabled) {
  background: linear-gradient(135deg, #059669, #047857);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.btn-recupero-credito:disabled,
.btn-recupero-credito.disabled {
  background: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

.btn-recupero-credito-small {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.75rem;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(16, 185, 129, 0.2);
}

.btn-recupero-credito-small:hover:not(:disabled):not(.disabled) {
  background: linear-gradient(135deg, #059669, #047857);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.btn-recupero-credito-small:disabled,
.btn-recupero-credito-small.disabled {
  background: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

.dettaglio-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
  padding: 0;
  overflow: hidden;
}


.dettaglio-header {
  background: #0f5889;
  color: #fff;
  font-weight: 600;
  padding: 16px 24px;
  font-size: 1.1rem;
}

.text-right {
  text-align: right;
}

.section-caption {
  margin: 8px 0 12px 0;
  color: #17406d;
  font-size: .95rem;
}



.overlay-loading {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.searchbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.agent-dropdown {
  flex: 1 1 300px;
  min-width: 250px;
}
.clear-btn {
  background: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
}

.link {
  color: #0f5889;
  cursor: pointer;
  font-weight: 600;
}

.btn-primary {
  background: #17406d;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
}
.btn-secondary {
  background: #b0b8c1;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
}

.btn-tertiary {
  background: #17406d;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
}
.btn-tertiary.disabled,
.btn-tertiary:disabled {
  background: #b0b8c1;
  cursor: not-allowed;
}

.w-100 { width: 100%; }
.field { display: flex; flex-direction: column; gap: 6px; }

.contatti-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.filters-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-field label {
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
}

.filters-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}

.agente-master-header,
.firmatario-header,
.no-rappresentanti-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  padding: 12px 16px;
  background-color: #f8fafc;
  border-radius: 6px;
  margin-bottom: 8px;
}

.loading-indicator {
  color: #0f5889;
  font-size: 0.9rem;
}

.loading-content {
  padding: 20px;
  text-align: center;
  color: #6b7b8c;
}

.empty-level {
  padding: 16px;
  text-align: center;
  color: #6b7b8c;
  font-style: italic;
}

.empty-state {
  background: #f8fafc;
  border: 1px dashed #b0b8c1;
  border-radius: 8px;
  padding: 26px;
  text-align: center;
  color: #6b7b8c;
  margin: 50px 0;
}

.page-loader {
  display: flex;
  justify-content: flex-end;
  align-items: right;
  padding: 50px 32px;
}

.filters-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-field label {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.btn-180gg {
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.2);
  margin-top: 20px;
}

.btn-180gg:hover {
  background: linear-gradient(135deg, #4f46e5, #3730a3);
  box-shadow: 0 4px 8px rgba(99, 102, 241, 0.3);
  transform: translateY(-1px);
}

.btn-180gg.active {
  background: linear-gradient(135deg, #059669, #047857);
  box-shadow: 0 4px 8px rgba(5, 150, 105, 0.3);
}

.btn-180gg.active:hover {
  background: linear-gradient(135deg, #047857, #065f46);
}

.btn-180gg:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

</style>